module.exports = __webpack_public_path__ + "img/clock.dbbff17d.svg";